<template>
  <div>
    <!-- AI导航入口 -->
    <div class="right-box">
      <div class="right-title">
        <span>AI导航</span>
        <a href="https://www.chatglobal.com/" target="_blank">更多</a>
      </div>
      <div class="ai-nav-card">
        <a href="https://www.chatglobal.com/" target="_blank" class="ai-nav-link">
          <div class="ai-nav-logo">
            <span class="ai-nav-logo-text">CG</span>
          </div>
          <div class="ai-nav-info">
            <div class="ai-nav-name">ChatGlobal</div>
            <div class="ai-nav-desc">全球AI入口 · 400+ AI产品</div>
          </div>
        </a>
      </div>
      <div class="ai-nav-card ai-rank-card">
        <a href="https://www.chatglobal.com/index.php?_a=ai_index&f=ranking&board_id=1&cycle=week&lang=zh-CN" target="_blank" class="ai-nav-link">
          <div class="ai-nav-logo ai-rank-logo">
            <span class="ai-nav-logo-text">榜</span>
          </div>
          <div class="ai-nav-info">
            <div class="ai-nav-name">AI风云榜</div>
            <div class="ai-nav-desc">全球AI站点每周人气风云榜</div>
          </div>
        </a>
      </div>
    </div>

    <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
         <a href="/enterprise/#/list?field=全部&category=全部" target="_blank">更多</a>
      </div>
      <ul class="platform">
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=文心一言" target="_blank">文心一言</a></li>
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=通义千问" target="_blank">通义千问 </a></li>
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=Kimi" target="_blank">Kimi</a></li>
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=ChatGPT" target="_blank">ChatGPT</a></li>
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=DeepSeek" target="_blank">DeepSeek</a></li>
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=元宝" target="_blank">元宝</a></li>
        <li><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw=松鼠 ai" target="_blank">松鼠AI</a></li>
      </ul>
      <!-- <Company /> -->
    </div>

    <div class="right-box">
      <div class="right-title">
        <span>AI人物</span>
         <a href="/Index/wjs_search_res.html?kw=AI" target="_blank">更多</a>
      </div>
      <!-- 易纲 尚福林 郭树清 易会满 井贤栋 罗敏 张俊 唐宁 孙陶然 周晔 -->
      <ul class="platform">
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=李彦宏" target="_blank">李彦宏</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=马化腾 ai" target="_blank">马化腾</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=马云 AI" target="_blank">马云</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=周鸿祎 人工智能" target="_blank">周鸿祎</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=张一鸣" target="_blank">张一鸣</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=张鹏" target="_blank">张鹏</a></li>
      </ul>
      <!-- <ul class="platform">
        <li v-for="(text,index) of renwu" :key="index"><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw='text'"></a>{{text}}</li>
      </ul> -->
    </div>
    <div class="right-box">
      <div class="right-title">
        <span>AI专家</span>
         <a href="/Index/wjs_search_res.html?kw=AI" target="_blank">更多</a>
      </div>
      <!-- 易纲 尚福林 郭树清 易会满 井贤栋 罗敏 张俊 唐宁 孙陶然 周晔 -->
      <ul class="platform">
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=曹磊 AI" target="_blank">曹磊</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=陈礼腾 AI" target="_blank">陈礼腾</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=郭涛 AI" target="_blank">郭涛</a></li>
        <li><a href="//www.100ec.cn/Index/wjs_search_res.html?kw=郑吉昌 AI" target="_blank">郑吉昌</a></li>
      </ul>
      <!-- <ul class="platform">
        <li v-for="(text,index) of renwu" :key="index"><a href="http://www.100ec.cn/Index/wjs_search_res.html?kw='text'"></a>{{text}}</li>
      </ul> -->
    </div>
    <!-- <div style="width: 365px">
        <a href="https://www.100ec.cn/zt/wswjsxfpgyl/" target="_blank">
          <img style="width: 100%" src="/Public/home/images/zyttk/xfpjr1.jpg" />
        </a>
      </div> -->
    <Email />
    <!-- <div class="right-box">
      <div class="right-title">
        <span>热门投诉</span>
        <a href="/Index/complain.html" target="_blank">我要投诉</a>
      </div>

      <ul class="platform">
        <li
          v-for="(i, index) of platform"
          :key="index"
          @click="getPlatform(index)"
        >
          {{ i }}
          <i class="fa fa-fire fa-lg"></i>
        </li>
      </ul>
    </div> -->
    <div class="right-box" style="padding: 0px;">
      <a href="/detail--6657650.html" target="_blank">
        <img src="//www.100ec.cn/Public/tuku/69cb39ddf1434.jpg" style="width: 100%; margin: 0 auto;height:1740px"/>
      </a>
    </div>
    <!-- <div class="right-box">
      <div class="right-title">
        <span>图书推荐</span>
      </div>

      <a
        href="http://www.100ec.cn/zt/hlwhpjr/"
        target="_blank"
      >
        <img
          src="/Public/Upload/hlwphjr.jpg"
          style="width: 80%; margin: 0 auto 20px"
        />
      </a>
      
    </div> -->
        
  </div>
</template>
<script>
export default {
  name: "ContentR",
  data() {
    return {
      params: {
        field: "金融科技",
        tabs: ["数字金融", "保险", "银行", "征信", "支付"],
      },
      year: "",
      time: "",
      platform: [],
      // renwu:["易纲", "尚福林", "郭树清", "易会满", "井贤栋", "罗敏", "张俊", "唐宁", "孙陶然", "周晔","肖文杰", "赵国庆", "沈鹏", "杨一夫", "计葵生", "叶大清", "周世平", "董骏","陈宝国", "郭宇航", "姚宏", "曹磊", "张周平", "莫岱青", "黄震", "叶檀", "余丰慧"]
    };
  },
  created() {
    this.$store.commit("getCompanyTabs", this.params);
  },
  mounted() {
    if (new Date().getMonth >= 2) {
      this.year = new Date().getFullYear();
    } else {
      this.year = new Date().getFullYear() - 1;
      this.time = "whole_year";
    }
    axios
      .get(
        "https://www.100ec.cn/315/api/index.php?_a=product&f=most_company_list&type=77"+
          "&limit=20&year=" +
          this.year +
          "&time=" +
          this.time
      )
      .then((res) => {
        for (var i of res.data.list) {
          this.platform.push(i.company);
        }
      });
  },
  methods: {
    getPlatform(index) {
      window.open(
        "/Index/complain_search.html?company=" + this.platform[index]
      );
    },
  },
};
</script>
<style scoped>
/* 右板块整体紧凑化 */
.right-box {
  padding: 12px 14px !important;
  margin-bottom: 12px !important;
}

.right-title {
  margin-bottom: 8px !important;
  font-size: 15px !important;
}

.right-title span {
  font-size: 15px !important;
  font-weight: bold;
}

.platform {
  gap: 6px !important;
}

.platform li {
  font-size: 12px !important;
  padding: 3px 10px !important;
  margin: 0 !important;
  height: auto !important;
  line-height: 1.6 !important;
}

.platform a {
  font-size: 12px !important;
}

/* AI导航卡片 - 更紧凑 */
.ai-nav-card {
  padding: 0;
}

/* AI风云榜卡片 */
.ai-rank-card {
  margin-top: 8px;
}

.ai-rank-card .ai-nav-link {
  background: linear-gradient(135deg, #f7f6ff 0%, #efedff 100%);
  border: 1px solid #e3ddff;
}

.ai-rank-card .ai-nav-link:hover {
  border-color: #6d4aff;
  box-shadow: 0 2px 6px rgba(109, 74, 255, 0.14);
}

.ai-rank-card .ai-nav-logo {
  background: linear-gradient(135deg, #4f3ddb 0%, #7c4dff 100%);
}

.ai-nav-link {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: linear-gradient(135deg, #f8faff 0%, #eef4ff 100%);
  border: 1px solid #e4ecff;
  border-radius: 6px;
  text-decoration: none;
  transition: all .25s;
}

.ai-nav-link:hover {
  border-color: #ff6200;
  box-shadow: 0 2px 6px rgba(255, 98, 0, 0.12);
  transform: translateY(-1px);
}

.ai-nav-logo {
  flex: 0 0 36px;
  height: 36px;
  border-radius: 8px;
  background: linear-gradient(135deg, #ff6200 0%, #ff8f00 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.ai-nav-logo-text {
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: -0.5px;
}

.ai-nav-info {
  flex: 1;
  min-width: 0;
}

.ai-nav-name {
  font-size: 14px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 2px;
}

.ai-nav-desc {
  font-size: 11px;
  color: #909399;
  line-height: 1.4;
}
</style>